import axios from "axios";
import config from "../../config/config";
import { CreateModuleInputs, Module, UpdateModuleInputs } from "./modules.interfaces";

const API_URL = `${config.apiBaseUrl}/modules`;

const axiosClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: config.defaultTimeout,
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Busca todos os módulos
 * @returns Lista de módulos
 */
export const apiGetModules = async (): Promise<Module[]> => {
  try {
    const response = await axiosClient.get<Module[]>("");
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error during get modules:", error.message);
    } else {
      console.error("Unexpected error during get modules:", error);
    }
    throw error;
  }
};

/**
 * Busca um módulo específico pelo ID
 * @param id ID do módulo
 * @returns Detalhes do módulo
 */
export const apiGetModule = async (id: string): Promise<Module> => {
  try {
    const response = await axiosClient.get<Module>(`/${id}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(`Axios error during get module ${id}:`, error.message);
    } else {
      console.error(`Unexpected error during get module ${id}:`, error);
    }
    throw error;
  }
};

/**
 * Cria um novo módulo
 * @param data Dados do módulo a ser criado
 * @returns ID do módulo criado
 */
export const apiCreateModule = async (data: Omit<CreateModuleInputs, 'packageId'>): Promise<string> => {
  try {
    const response = await axiosClient.post<string>("", data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error during create module:", error.message);
    } else {
      console.error("Unexpected error during create module:", error);
    }
    throw error;
  }
};

/**
 * Atualiza um módulo existente
 * @param id ID do módulo a ser atualizado
 * @param data Dados de atualização do módulo
 */
export const apiUpdateModule = async (id: string, data: UpdateModuleInputs): Promise<void> => {
  try {
    await axiosClient.put(`/${id}`, data);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(`Axios error during update module ${id}:`, error.message);
    } else {
      console.error(`Unexpected error during update module ${id}:`, error);
    }
    throw error;
  }
};

/**
 * Exclui um módulo
 * @param id ID do módulo a ser excluído
 */
export const apiDeleteModule = async (id: string): Promise<void> => {
  try {
    await axiosClient.delete(`/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(`Axios error during delete module ${id}:`, error.message);
    } else {
      console.error(`Unexpected error during delete module ${id}:`, error);
    }
    throw error;
  }
}; 